import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, provideEnvironmentInitializer } from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupById,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { SOFTLINE_CONFIG_INDEXED_DB, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { StempelTerminalTimeoutInterceptor } from './interceptors/timeout.interceptor';
import { SOFTLINE_PERMISSION_STEMPELTERMINAL } from './stempel-terminal.permissions';
import { pmsStempelTerminalRoutes } from './stempel-terminal.routes';
import { provideStempelTerminalGlobals } from './stempel-terminal.globals';
import { SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_INDEXED_DB_STORE } from './time-clock.indexed-db';

export function provideStempelTerminalModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'stempel-terminal',
        title: '#STEMPELTERMINAL.TITLE',
        icon: 'fa-regular fa-nfc-signal',
        route: '/stempel-terminal',
        permission: SOFTLINE_PERMISSION_STEMPELTERMINAL,
        group: getModuleGroupById(8),
      },
      withSoftAppsModuleRoutes({ terminal: pmsStempelTerminalRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
    ...provideStempelTerminalGlobals(),
  ];
}

export const pmsStempelTerminalProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'stempel-terminal',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Stempel-Terminal',
      icon: 'fa-regular fa-nfc-signal',
      route: '/stempel-terminal',
      permission: SOFTLINE_PERMISSION_STEMPELTERMINAL,
      group: getModuleGroupById(8), // Personalmanagement
    });
  }),
  {
    provide: SOFTLINE_CONFIG_INDEXED_DB,
    multi: true,
    useValue: SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_INDEXED_DB_STORE,
  },
  {
    provide: HTTP_INTERCEPTORS,
    multi: true,
    useClass: StempelTerminalTimeoutInterceptor,
  },
];
